import type { ReactNode } from "react";

import { cx } from "./ui";

/**
 * CRT / hosted-TUI window chrome.
 */
export function TerminalFrame({
  title,
  status,
  children,
  footer,
  className,
}: {
  title: string;
  status?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={cx(
        "flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border border-border bg-frame",
        className,
      )}
    >
      <header className="flex shrink-0 items-center gap-3 border-b border-teal/10 px-4 py-2.5">
        <span className="flex gap-1.5" aria-hidden>
          <span className="h-2.5 w-2.5 rounded-full bg-[#ff5f56]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#ffbd2e]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#27c93f]" />
        </span>
        <span className="font-mono text-[12px] tracking-wide text-teal">{title}</span>
        {status ? <div className="ml-auto font-mono text-[11px] text-mute">{status}</div> : null}
      </header>
      <div className="flex min-h-0 flex-1 flex-col">{children}</div>
      {footer ? (
        <footer className="shrink-0 border-t border-teal/10 px-3 py-2.5 text-[12px] text-mute">
          {footer}
        </footer>
      ) : null}
    </section>
  );
}
